export default "__VITE_ASSET__CMjshLry__"